module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-700italic.b4f4ebd828ca4b98401f3b3164cc123f.woff";